import React from "react";
import TenantConfigTab from "../TenantConfigTab";

const OnboardingStepBusinessConfig = ({ configs, disabled, onSave }) => (
  <div className="space-y-4">
    <p className="text-sm text-slate-500">
      Configure business hours, AI behaviour, notification preferences, and branding for this business.
    </p>
    <TenantConfigTab configs={configs} disabled={disabled} onSave={onSave} />
  </div>
);

export default OnboardingStepBusinessConfig;
